import { render, staticRenderFns } from "./usages.vue?vue&type=template&id=5a394e11&"
import script from "./usages.vue?vue&type=script&lang=js&"
export * from "./usages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports